import { Fragment } from "react";
import { Outlet } from "react-router-dom";
import useAuthVerifier from "providers/AuthVerifierProvider/useAuthVerifier";
import PageContainer from "components/PageContainer";
import PublicRoutes from "components/App/PublicRoutes";
import TimeZoneAutoSetter from "components/TimeZoneAutoSetter";
import ScreenSizeTooSmall from "features/ScreenSizeToSmall";
import InitializerProviders from "../config/InitializerProviders";
import ConfigProviders from "../config/ConfigProviders";

/**
 * AuthenticatedShell is the layout route for every screen that requires a signed in user.
 *
 * While authentication is being verified it renders nothing, and signed out visitors get
 * the public routes instead. Once a user is verified it mounts the provider stack the
 * authenticated screens depend on and renders the matched route through its Outlet:
 *
 * - InitializerProviders provides necessary context for the app initialization. It includes:
 *   - DataProviders and LoadingProvider for essential data fetching and loading state management.
 * - ConfigProviders provides global/not essential for the app configuration.
 */
function AuthenticatedShell() {
  const { status, data } = useAuthVerifier();

  if (status === "fetching") return <span />;

  if (!data) return <PublicRoutes />;

  return (
    <Fragment>
      <InitializerProviders>
        <ConfigProviders>
          <TimeZoneAutoSetter />
          <PageContainer>
            <Outlet />
          </PageContainer>
        </ConfigProviders>
      </InitializerProviders>
      <ScreenSizeTooSmall />
    </Fragment>
  );
}

export default AuthenticatedShell;
